import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { track } from "@/lib/analytics";

const PHONE_RAW = "262692714505"; // +262 692 71 45 05
const DEFAULT_MSG = encodeURIComponent(
  "Bonjour, je vous contacte depuis votre site SAD. Je souhaiterais discuter d'un projet d'agencement."
);
const WA_URL = `https://wa.me/${PHONE_RAW}?text=${DEFAULT_MSG}`;

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [hint, setHint] = useState(true);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    onScroll();
    const t = setTimeout(() => setHint(false), 6000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
    };
  }, []);

  const handleClick = () => {
    track(
      "whatsapp_click",
      { source: "floating_button" },
      "Contact",
      { method: "whatsapp" }
    );
  };

  return (
    <div
      data-testid="whatsapp-floating"
      className={`fixed bottom-5 right-5 z-50 flex items-end gap-3 transition-all duration-500 sm:bottom-8 sm:right-8 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      {hint && visible && (
        <div className="hidden items-center gap-2 rounded-full border border-stone-200 bg-white px-4 py-2 text-sm text-stone-700 shadow-lg sm:flex">
          <span>Discutons sur WhatsApp 👋</span>
          <button
            onClick={() => setHint(false)}
            aria-label="Fermer"
            className="rounded-full p-1 text-stone-400 hover:bg-stone-100 hover:text-stone-700"
          >
            <X className="h-3.5 w-3.5" strokeWidth={1.5} />
          </button>
        </div>
      )}

      <a
        data-testid="whatsapp-cta"
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contacter SAD sur WhatsApp"
        onClick={handleClick}
        className="group relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.65)] transition-all hover:scale-105 hover:bg-[#1ebe5b]"
      >
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
        <MessageCircle className="h-6 w-6" strokeWidth={1.8} />
      </a>
    </div>
  );
}
